<template>
  <paginated-content :items="sessions" :perPage="pageSize" :parent-id="parentId">
    <template v-slot="{ displayItems }">
      <div class="sessions-list">
        <div v-for="(session, index) in displayItems" :key="`search-${session.id}`">
          <div class="date-container" v-if="!hideDays && session.showDate" :class="{ 'mt-0': index === 0 }">
            <div class="subtitle has-text-primary is-4 has-text-weight-bold">
              {{ dayjs(session.agenda_session_day.only_date).format("D MMMM") }}
            </div>
            <hr v-if="isScientificTheme" />
          </div>

          <agenda-session
            @open-user-modal="$emit('open-user-modal', $event)"
            @open-auth="$emit('open-auth')"
            @open-agenda-session-attendees="$emit('open-agenda-session-attendees', $event)"
            @open-agenda-session-questions="$emit('open-agenda-session-questions', $event)"
            @open-auth-lw-stream="$emit('open-auth-lw-stream', $event)"
            :session="session"
            :session-ratings="sessionRatings"
            :hide-session-time="hideSessionTime"
            :show-live-indicator="showLiveIndicator"
            :hide-live-stream-buttons="hideLiveStreamButtons"
            :customSponsor="getCustomSponsor(session.id)"
            :searchQuery="searchQuery"
          ></agenda-session>
        </div>
      </div>
    </template>
  </paginated-content>
</template>

<script>
import PaginatedContent from "@/shared/components/common/pagination/PaginatedContent";
import AgendaSession from "@/widgets/agenda/components/sessions/AgendaSession";
import dayjs from '@/shared/utils/day';
import { mapState } from "vuex";
import Constants from "@/widgets/shared/constants";

export default {
  name: "AgendaSessionsSearchPagerView",

  props: {
    sessions: {
      type: Array,
    },

    searchQuery: {
      type: String,
      required: true,
    },

    sessionRatings: {
      type: Array,
    },

    hideDays: {
      type: Boolean,
    },

    hideSessionTime: {
      type: Boolean,
    },

    showLiveIndicator: {
      type: Boolean,
    },

    pageSize: {
      type: Number,
    },

    hideLiveStreamButtons: {
      type: Boolean,
    },
    customSponsors: {
      type: String,
    },
    parentId: {
      type: String,
    },
  },

  components: {
    PaginatedContent,
    AgendaSession,
  },

  computed: {
    ...mapState(["theme"]),

    dayjs: () => dayjs,

    parsedSponsors() {
      return this.customSponsors && JSON.parse(this.customSponsors);
    },

    isScientificTheme() {
      return this.theme === Constants.WIDGET_THEME_TYPES.SCIENTIFIC;
    },
  },

  methods: {
    getCustomSponsor(agendaSessionId) {
      return this.parsedSponsors && this.parsedSponsors.find(item => item.agenda_session_id === agendaSessionId);
    },
  },
};
</script>

<style lang="scss" scoped>
.columns {
  flex-wrap: wrap;
}

.date-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 18px;
  margin-bottom: 18px;
  margin-top: 24px;

  @media screen and (max-width: 920px), print {
    margin-top: 24px !important;
  }

  > hr {
    flex-grow: 1;
    height: 2px;
    background-color: var(--primary-color);
    border-radius: 4px;
    margin-top: 18px;
  }
}
</style>
